import React, { useContext } from 'react';
import { Disclosure } from '@headlessui/react';
import  Link  from "next/link";
import { useRouter } from "next/router";
import { HideCategoryMenuContext } from '@/component/shared/hsn/hsnFindercommon';

const animal = [
  { name: 'Loreum Ipsum', href: '#' },
  { name: 'Loreum Ipsum', href: '#' },
  { name: 'Loreum Ipsum', href: '#' },
  { name: 'Loreum Ipsum', href: '#' },
]

const frozen = [
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
]

const dairy = [
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
    { name: 'Loreum Ipsum', href: '#' },
]

const Categorymenu=()=> {
    const router = useRouter();
    const {open, setOpen} = useContext(HideCategoryMenuContext);
    // const hideMenuOnMain=()=> {
    //   setOpen(false)
    // }
  
    return (
        <div className="overflow-y-auto border-l border-r border-[#ccc] bg-white">
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4" >
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "#" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Live Animals</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {animal.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link href={item.href}  rel="noopener noreferrer" onClick={()=>setOpen(false)} className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "/credlix/For-Enterprise" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Frozen Meat</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {frozen.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="/enterprise" onClick={()=>setOpen(false)} className={router.pathname == "" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Dairy Products</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {dairy.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href} target={item.target}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>    
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4" >
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "#" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Live Animals</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {animal.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link href={item.href}  rel="noopener noreferrer" onClick={()=>setOpen(false)} className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "/credlix/For-Enterprise" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Frozen Meat</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {frozen.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="/enterprise" onClick={()=>setOpen(false)} className={router.pathname == "" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Dairy Products</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {dairy.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href} target={item.target}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>    
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4" >
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "#" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Live Animals</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {animal.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link href={item.href}  rel="noopener noreferrer" onClick={()=>setOpen(false)} className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "/credlix/For-Enterprise" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Frozen Meat</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {frozen.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="/enterprise" onClick={()=>setOpen(false)} className={router.pathname == "" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Dairy Products</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {dairy.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href} target={item.target}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>    
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4" >
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "#" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Live Animals</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {animal.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link href={item.href}  rel="noopener noreferrer" onClick={()=>setOpen(false)} className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="#" onClick={()=>setOpen(false)} className={router.pathname == "/credlix/For-Enterprise" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Frozen Meat</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {frozen.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>
            <div className="text-sm font-semibold text-secondary w-full hover:bg-[#EFF5FA]">
            <Disclosure as="div">
                        {({ open }) => (
                          <>
                              <Disclosure.Button className="flex w-full items-center justify-between px-4">
                                <Link href="/enterprise" onClick={()=>setOpen(false)} className={router.pathname == "" ? "text-brand flex justify-between py-3" : "flex justify-between py-3"}>Dairy Products</Link>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/></svg>
                                  ) : (
                                    <svg className="ml-1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/></svg>
                                  )}
                                </span>
                              </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4 ">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                <ul>
                                    {dairy.map((item) => (
                                        <li key={item.name} className={router.asPath == item.href ? "text-brand font-medium" : "font-regular"}>
                                            <Link onClick={()=>setOpen(false)} href={item.href} target={item.target}  rel="noopener noreferrer" className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand">{item.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
            </Disclosure>
            </div>    
    </div>
    )
        
    
    

}

export default Categorymenu;

